import Box from "@mui/material/Box";
import BreadCrumb from "app/components/BreadCrumb";
import { ScrollableView } from "app/components/ScrollableView";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";

import ActionBar from "./components/ActionBar";
import AddManufacturerModal from "./components/AddManufacturerModal";
import ManufacturerTable from "./components/ManufacturerTable";
import {
  selectManufacturersList,
  selectManufacturersLoading,
  selectManufacturersMeta,
} from "./redux/selector";
import { manufacturerSaga } from "./redux/saga";
import { manufacturerActions, reducer, sliceKey } from "./redux/slice";
import { useStyles } from "./style";

const Manufacturer = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  useInjectSaga({
    key: sliceKey,
    saga: manufacturerSaga,
  });

  const rows = useSelector(selectManufacturersList);
  const loading = useSelector(selectManufacturersLoading);
  const meta = useSelector(selectManufacturersMeta);

  useEffect(() => {
    dispatch(manufacturerActions.getManufacturersList());
  }, [dispatch]);

  const hasMoreItems = meta.currentPage < meta.totalPages;

  const getNextPage = () => {
    if (!loading && hasMoreItems) {
      dispatch(manufacturerActions.getNextPageItems());
    }
  };

  return (
    <Box className={styles.container}>
        <Box className={styles.scrollContent} dir={i18n.dir()}>
          <Box className={styles.pageContent}>
            <BreadCrumb title={t("SIDEBAR.MANUFACTURERS")} iconPosition="end" />
            <ActionBar onAddClick={() => dispatch(manufacturerActions.openAddModal())} />
            <Box className={styles.tableContainer}>
              <ScrollableView
                borderless
                height="calc(100vh - 200px)"
                loadMore={getNextPage}
                hasMoreItems={hasMoreItems}
              >
                <ManufacturerTable rows={rows} loading={loading} />
              </ScrollableView>
            </Box>
          </Box>
        </Box>
      <AddManufacturerModal />
    </Box>
  );
};

export default Manufacturer;
